import { Link } from 'react-router-dom';
import { ArrowUpRight, Building2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import { AgencyTierBadge, type AgencyTier } from './AgencyTierBadge';

interface Props {
  id: string;
  name: string;
  logoUrl?: string | null;
  saleCount: number;
  rentCount: number;
  highlighted?: boolean;
  tier?: AgencyTier;
}

export function TitaniumAgencyCard({ id, name, logoUrl, saleCount, rentCount, highlighted, tier }: Props) {
  const summary = saleCount && rentCount
    ? `${saleCount} for Sale | ${rentCount} for Rent`
    : saleCount ? `${saleCount} for Sale` : rentCount ? `${rentCount} for Rent` : 'No active listings';

  return (
    <Link
      to={`/agencies/${id}`}
      className={cn(
        'snap-start shrink-0 w-[320px] h-[120px] flex items-center gap-3 p-3 rounded-lg border bg-card hover:shadow-md transition-all relative',
        highlighted && 'border-primary ring-1 ring-primary/40'
      )}
    >
      {tier && (
        <span className="absolute top-2 right-2">
          <AgencyTierBadge tier={tier} size="sm" />
        </span>
      )}
      <div className="h-[88px] w-[88px] shrink-0 rounded-md border bg-muted/30 flex items-center justify-center overflow-hidden">
        {logoUrl ? (
          <img src={logoUrl} alt={name} className="h-full w-full object-contain" />
        ) : (
          <Building2 className="h-8 w-8 text-muted-foreground" />
        )}
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="font-bold text-sm truncate">{name}</h3>
        <p className="text-xs text-muted-foreground mt-1">{summary}</p>
        <span className="inline-flex items-center gap-1 text-xs text-primary font-medium mt-2">
          View Agency Properties <ArrowUpRight className="h-3 w-3" />
        </span>
      </div>
    </Link>
  );
}
